import React from 'react';

import { App } from './App';
import { StateProvider } from './context';

export const AppointmentTool = () => (
    <StateProvider>
        <App />
    </StateProvider>
);
